interface Capability {
  title: string;
  description: string;
}

const capabilities: Capability[] = [
  {
    title: 'Competitor tracking',
    description:
      'Watch every yacht in your market. Specs, photos, availability, calendars, all kept current.',
  },
  {
    title: 'Price & availability tracking',
    description:
      'Exact rates and open weeks across the entire competitive set, refreshed continuously.',
  },
  {
    title: 'Tailored analytics',
    description:
      'Your fleet against your market. Segment by region, builder, length, and season the way you actually price.',
  },
  {
    title: 'Price-change alerts',
    description:
      'Get notified the moment anything moves. Daily digests or instant pings, your choice.',
  },
  {
    title: 'Dynamic pricing',
    description:
      'Rules that respond to demand and the competitive set. Suggested rates you can accept, edit, or override.',
  },
  {
    title: 'Revenue lift',
    description:
      'Quantified impact, season over season. See exactly what pricing decisions earned, and what they cost.',
  },
];

export function LandingFeatures() {
  return (
    <section id="features" className="scroll-mt-20 border-t border-border py-32 md:py-40">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-16 max-w-2xl">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
            Capabilities
          </p>
          <h2 className="text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
            Six tools, one tight loop: watch the market, price the fleet.
          </h2>
        </div>

        <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-border bg-border md:grid-cols-2 lg:grid-cols-3">
          {capabilities.map((capability, idx) => (
            <li
              key={capability.title}
              className="bg-background p-8 transition-colors hover:bg-muted/30"
            >
              <p className="mb-6 font-mono text-xs tabular-nums text-muted-foreground">
                {String(idx + 1).padStart(2, '0')}
              </p>
              <h3 className="mb-3 text-lg font-semibold text-foreground">{capability.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {capability.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
